import { theme, typographyRem } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { ProviderContext } from '../../Provider'
import { FAQAccordionBody } from '../FAQs/FAQAccordionBody'
import { FAQAccordionHeader } from '../FAQs/FAQAccordionHeader'
import Accordion from '../shared/AccordionV2'
const { paragraphBody: ParagraphBody } = typographyRem

const FAQAccordionStyled = styled.div`
  .accordion__item {
    margin-bottom: ${theme.grid.spacing.s}px;
  }
`

export const FAQAccordion = () => {
  const {
    state: { showModal },
  } = useContext(ProviderContext)
  const tabFocusTrap = showModal ? -1 : 0
  return (
    <FAQAccordionStyled>
      <Accordion>
        <Accordion.Item index="Can I protect my No Claims Discount (NCD)?">
          <FAQAccordionHeader tabFocusTrap={tabFocusTrap}>
            Can I protect my No Claims Discount (NCD)?
          </FAQAccordionHeader>
          <FAQAccordionBody>
            <ParagraphBody>
              No Claims Discount (also known as No Claims Bonus) protection is included as standard with every By Miles
              policy.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              If you leave us, we'll tell your new insurer the NCD you've protected, and the exact number of whole
              claim-free years you were with us.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              It's worth noting that No Claims Discount protection doesn't protect the overall price of your insurance
              policy. The price of your insurance policy may increase following an accident, even if you were not at
              fault.
            </ParagraphBody>
          </FAQAccordionBody>
        </Accordion.Item>
        <Accordion.Item index="What kind of coverage does By Miles offer?">
          <FAQAccordionHeader tabFocusTrap={tabFocusTrap}>
            What kind of coverage does By Miles offer?
          </FAQAccordionHeader>
          <FAQAccordionBody>
            <ParagraphBody>
              We provide comprehensive cover which is currently rated 'Excellent' on Trustpilot by our members.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              You'll also get comprehensive cover in any EU country, as well as Norway, Iceland, Switzerland,
              Liechtenstein, and Andorra. That's for up to 90 days in any one period of insurance.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              All of our policies provide cover for social, domestic and pleasure use as standard.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              We'll also automatically add commuting use and business use for free where we can, but this depends on the
              details you enter when you get a quote. You'll need to check the type of cover offered on the quote page
              before you buy.
            </ParagraphBody>
          </FAQAccordionBody>
        </Accordion.Item>
        <Accordion.Item index="Will we change your price if you're speeding?">
          <FAQAccordionHeader tabFocusTrap={tabFocusTrap}>
            Will we change your price if you're speeding?
          </FAQAccordionHeader>
          <FAQAccordionBody>
            <ParagraphBody>
              Unlike many car insurance policies that use a black box, our policies are 'Pay As You Drive', not 'How You
              Drive'.
            </ParagraphBody>
            <br />
            <ParagraphBody>
              That means we'll only price your insurance based on the distance you drive. We'll never share any of your
              personal driving data with the police, unless we're obliged to as a direct result of a court order.
            </ParagraphBody>
          </FAQAccordionBody>
        </Accordion.Item>
      </Accordion>
    </FAQAccordionStyled>
  )
}
